// extracted by mini-css-extract-plugin
export default {"wrapper":"spacing-layout_wrapper__TvUGr"};